import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "antd";
import { makeRequest } from '@utils/helpers';
import { useParams } from "react-router-dom";
import { getPetBookingCarePlan } from './requests';
import { PrinterOutlined } from "@ant-design/icons";
import { useSelector } from 'react-redux';
import { HeaderComponent, BodyComponent, TableComponent, ActionComponent, CreateButton, ButtonComponent } from "@comps/components";
const webData = localStorage.getItem('webData') ? JSON.parse(localStorage.getItem('webData')) : {};
const moment = require('moment');

const BookingCarePlan = () => {
  const crmStyle = useSelector(state => state.common.crmStyle);
  const { id } = useParams();
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState();
  const [settings, setSettings] = useState("");


  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  const getData = () => {
    makeRequest(setLoader, getPetBookingCarePlan, id, onSuccess, onError);
  }

  const onSuccess = (res) => {
    setData(res.pets);
    setSettings(res.terms);
  }

  const onError = (error) => {

  }


  if (!data) return null;

  return (
    <>
      <div>
        <Row gutter={ 16 } className="da-text-center">
          <Col span={ 24 }>
            <CreateButton
              style={ { background: crmStyle.bg_color, border: crmStyle.border_color, float: 'left' } }
              className="hideonprint"
              type="primary"
              icon={ <PrinterOutlined /> }
              onClick={ () => window.print() }
              text="Print"
            >
            </CreateButton>
          </Col>
          <Col span={ 24 } style={ { display: 'flex', justifyContent: 'center', alignItems: 'center' } }>
            <div className="boxcareplan">
              <h2 style={ { padding: 0, margin: 0 } }>{ settings.title }</h2>
            </div>
          </Col>
        </Row>
        <Row gutter={ 16 }>
          <Col span={ 24 } className="daycareplan">
            <table border="1" width="100%">
              <tr>
                <td colspan="5" style={ { padding: '0px' } }>
                  <Row>
                    <Col span={ 4 } style={ { borderRight: '1px solid gray', padding: 10 } }><strong>REF:  { data[0].booking.id }</strong></Col>
                    <Col span={ 15 } style={ { fontWeight: 'bold', textAlign: 'center', borderRight: '1px solid gray', padding: 10 } }>BOARDING BOOKING FORM</Col>
                    <Col span={ 5 } style={ { padding: '10px 0px 0px 10px ' } }><strong>DATE: { moment(data[0].booking.end_date).format('DD/MM/YYYY') }</strong></Col>
                  </Row>
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  <div style={ { display: 'flex', justifyContent: 'space-between', paddingRight: '30px' } }>
                    <div style={ { display: 'flex', flexDirection: 'column', width: '50%' } }>
                      <Row>
                        <Col span={ 6 } style={ { fontWeight: 'bold' } }>Customer:</Col>
                        <Col span={ 18 } style={ { fontWeight: 'bold' } }>{ data[0].pet.client.name }:</Col>
                      </Row>
                      <Row>
                        <Col span={ 6 } >Address:</Col>
                        <Col span={ 18 } >
                          <div style={ { width: '80%' } }>
                            { data[0].pet.client.clientinfo.address_line1 + " " + data[0].pet.client.clientinfo.address_line2 }
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div>
                      <p>Phone: { data[0].pet.client.clientinfo.phone }     <span style={ { marginLeft: '20px' } }>Mobile: { data[0].pet.client.clientinfo.mobile }</span> </p>
                      <p>Email: { data[0].pet.client.email } </p>
                      <p>Contact: { data[0].pet.client.clientinfo.phone }       <span style={ { marginLeft: '10px' } }>Phone: { data[0].pet.client.clientinfo.mobile }</span></p>
                      <p>Vet: { data[0].pet.vet_name } <span style={ { marginLeft: '15px' } }>Phone: { data[0].pet.vet_phone }</span></p>
                    </div>
                  </div>
                  <div style={ { marginTop: '20px' } }>
                    <table border="1" width="90%">
                      <tr>
                        <th>Pet's name</th>
                        <th>Type</th>
                        <th>Breed</th>
                        <th>Code</th>
                        <th>Rate £</th>
                        <th>Ken</th>
                        <th>Share</th>
                      </tr>
                      { data.map((item) =>
                        <tr>
                          <td style={ { padding: 5, textAlign: 'center' } }>{ item.pet.name }</td>
                          <td style={ { padding: 5, textAlign: 'center' } }>{ item.pet.pet_type.name }</td>
                          <td style={ { padding: 5, textAlign: 'center' } }>{ item.pet.breed }</td>
                          <td style={ { padding: 5, textAlign: 'center' } }>{ item.pet.id }</td>
                          <td style={ { padding: 5, textAlign: 'center' } }>0</td>
                          <td style={ { padding: 5, textAlign: 'center' } }>0</td>
                          <td style={ { padding: 5, textAlign: 'center' } }>0</td>
                        </tr>
                      ) }
                    </table>
                  </div>
                  <div style={ { marginTop: '20px' } }>
                    <p>Arrival date : { moment(data[0].booking.start_date).format('dddd, MMM, YYYY') }</p>
                    <p>Departure date : { moment(data[0].booking.end_date).format('dddd, MMM, YYYY') }</p>
                    <p>Number of kennels required: { moment(data[0].booking.end_date).format('dddd, MMM, YYYY') }</p>
                    <p>Boarding fee: £{ Number(data[0].booking.total_price).toFixed(2) }</p>
                    <div style={ { display: 'flex', justifyContent: 'space-between', paddingRight: '30px', marginTop: '30px' } }>
                      <div>Total fee: £{ Number(data[0].booking.total_price).toFixed(2) }</div>
                      <div>Deposit: £{ Number(data[0].booking.paid_deposit).toFixed(2) }</div>
                      <div><strong>Balance: £{ Number(Number(data[0].booking.total_price) - Number(data[0].booking.paid_deposit)).toFixed(2) }</strong></div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="5">
                  <div>
                    <p dangerouslySetInnerHTML={ { __html: settings.terms } }></p>
                  </div>
                  <Row gutter={ 16 } className="da-mt-32">
                    <Col span={ 12 }><h5>Customer's signature __________</h5></Col>
                    <Col span={ 12 }><h5>Date __________</h5></Col>
                  </Row>
                </td>
              </tr>
            </table>


          </Col>
        </Row>

      </div>
    </>
  );
}

export default BookingCarePlan;